import { useContext, useEffect, useState } from 'react'
import GlobalContext from '../../../../../../../../context/global-context'
import { OrganizationAPI } from '../../../../../../../../api/organization.api'
import { cargarCuotasPrestamo } from './prestamoCuotas'
import { getPrestamoStatus } from './prestamoEstado'

const PrestamoStatus = ({ row }) => {
  const { currentBusiness } = useContext(GlobalContext)
  const [status, setStatus] = useState(null)
  const id = row.idPrincipal || row.id
  useEffect(() => {
    let active = true
    setStatus(null)
    new OrganizationAPI().getDataLibroContable(currentBusiness.id, id, 'vinculos')
      .then(({ data }) => {
        if (active) setStatus(getPrestamoStatus(cargarCuotasPrestamo({ ...row, ...data }, true).filter(cuota => cuota.fecha && cuota.capital !== '')))
      })
      .catch(() => { if (active) setStatus('No disponible') })
    return () => { active = false }
  }, [currentBusiness.id, id, row])
  const color = status === 'Conciliado' ? 'text-success bg-success/10'
    : status === 'Pendiente' ? 'text-danger bg-danger/10'
      : status === 'Parcialmente Conciliado' ? 'text-amber-700 bg-amber-100' : 'text-muted bg-border/40'
  return <span className={`inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.55rem] sm:text-[0.6rem] font-semibold uppercase tracking-wider leading-tight ${color}`}>{status ?? 'Cargando…'}</span>
}

export default PrestamoStatus
